import { unhandledError } from 'actions/appActions';

export const register = (window: Window, dispatch: Function) => {
    let inOnError: boolean = false;

    window.onerror = (msg: string, url: string, line: number, col: number, error: Error) => {
        if (inOnError) {
            console.error('Unhandled error while processing a previous error', error);
            return;
        }
        inOnError = true;
        dispatch(unhandledError({ msg, url, line, col, error }));
        inOnError = false;
    };
};


// WEBPACK FOOTER //
// ./src/startup/unhandledErrorHandler.tsx